import * as CL from '@design-system/component-library';
import { cancelMsg, confirmMsg, t } from '../../common/i18n/index.js';
import { Modal } from './Modal.js';
import { ModalButtons } from './ModalButtons.js';
import type { ReactNode } from 'react';

interface ConfirmationModalProps {
  heading: string;
  children: ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  className?: string;
  confirmText?: string;
  isLoading?: boolean;
  size?: 's' | 'm' | 'l' | 'xl';
}

export const ConfirmationModal = (props: ConfirmationModalProps) => {
  const { children, className, confirmText, heading, onCancel, onConfirm, size = 'm' } = props;

  return (
    <Modal closeable heading={heading} onClose={onCancel} className={className} size={size}>
      {children}
      <ModalButtons>
        <CL.Button color="link" key="btnCancel" onClick={onCancel}>
          {t.B2V1(cancelMsg)}
        </CL.Button>
        <CL.Button color="primary" key="btnConfirm" onClick={onConfirm} loading={props.isLoading}>
          {confirmText ?? t.QVYK(confirmMsg)}
        </CL.Button>
      </ModalButtons>
    </Modal>
  );
};
